"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobileBreakpoint = exports.isMediumBreakpoint = exports.isBelowBreakpoint = void 0;
var _sharedVariables = require("../shared-variables");
var breakpointMap = {
  xs: _sharedVariables.breakpoints.breakpointXs,
  sm: _sharedVariables.breakpoints.breakpointSm,
  md: _sharedVariables.breakpoints.breakpointMd,
  lg: _sharedVariables.breakpoints.breakpointLg,
  xl: _sharedVariables.breakpoints.breakpointXl,
  xxl: _sharedVariables.breakpoints.breakpointXxl
};

// is the current window width below the given breakpoint
var isBelowBreakpoint = exports.isBelowBreakpoint = function isBelowBreakpoint(_ref) {
  var width = _ref.width,
    breakpoint = _ref.breakpoint;
  return width < breakpointMap[breakpoint];
};

// pass useWindowWidth result into functions
var isMobileBreakpoint = exports.isMobileBreakpoint = function isMobileBreakpoint(width) {
  return width < _sharedVariables.breakpoints.breakpointMd;
};
var isMediumBreakpoint = exports.isMediumBreakpoint = function isMediumBreakpoint(width) {
  return width >= _sharedVariables.breakpoints.breakpointMd && width < _sharedVariables.breakpoints.breakpointLg;
};